import { fatal } from '../../../utils/log';

var DOMEvent = function DOMEvent ( name, owner, delegate ) {
	if ( name.indexOf( '*' ) !== -1 ) {
		fatal( ("Only component proxy-events may contain \"*\" wildcards, <" + (owner.name) + " on-" + name + "=\"...\"/> is not valid") );
	}

	this.name = name;
	this.owner = owner;
	this.delegate = delegate;
	this.node = null;
	this.handler = null;
};

DOMEvent.prototype.listen = function listen ( directive ) {
	var node = this.node = this.owner.node;
	var name = this.name;

	// this is probably a custom event fired from a decorator or manually
	if ( !( ("on" + name) in node ) ) { return; }

	node.addEventListener( name, this.handler = function( event ) {
		directive.fire({
			node: node,
			original: event,
			event: event,
			name: name
		});
	}, this.delegate );
};

DOMEvent.prototype.unlisten = function unlisten () {
	if ( this.handler ) { this.node.removeEventListener( this.name, this.handler, false ); }
};

var CustomEvent = function CustomEvent ( eventPlugin, owner, name ) {
	this.eventPlugin = eventPlugin;
	this.owner = owner;
	this.name = name;
	this.handler = null;
};

CustomEvent.prototype.listen = function listen ( directive ) {
		var this$1 = this;

	var node = this.owner.node;

	this.handler = this.eventPlugin( node, function ( event ) {
			if ( event === void 0 ) event = {};

		if ( event.original ) { event.event = event.original; }
		else { event.original = event.event; }

		event.name = this$1.name;
		event.node = event.node || node;
		directive.fire( event );
	});
};

CustomEvent.prototype.unlisten = function unlisten () {
	this.handler.teardown();
};

export { DOMEvent, CustomEvent };

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/element/ElementEvents.js.map
